// react and mui stuff
import { ReactElement } from 'react';

import Box from "@mui/joy/Box"
import Card from "@mui/joy/Card"
import CardContent from "@mui/joy/CardContent"
import Typography from "@mui/joy/Typography"
import Sheet from "@mui/joy/Sheet"
import Skeleton from "@mui/joy/Skeleton"

type props = {
  img: ReactElement
  name: string
  subtitle: string
  details: any[][]
  buttons: ReactElement[]
  loading?: boolean
}

const noflo = { minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }

export default function DetailCard(props: props) {
  return (
      <Card aria-hidden={false} orientation="horizontal" sx={{ maxWidth: '400px', width: "100%", flexWrap: 'wrap', overflow: 'auto', margin: "10px",
          [`& > *`]: {
            '--stack-point': '500px',
            minWidth:
              'clamp(0px, (calc(var(--stack-point) - 2 * var(--Card-padding) - 2 * var(--variant-borderWidth, 0px)) + 1px - 100%) * 999, 100%)',
          }
      }}>
        <CardContent sx={{width: "100%"}}>
          <Skeleton variant='rectangular' loading={props.loading} sx={{ aspectRatio: "16 / 9", width: "100%", height: "auto" }}>
            {props.img}
          </Skeleton>
          <Typography sx={{ fontSize: 'xl', fontWeight: 'lg', ...noflo }}>
            <Skeleton loading={props.loading}>{props.name}</Skeleton>
          </Typography>
          <Typography level="body-sm" textColor="text.tertiary" sx={{ fontWeight: 'lg', ...noflo }}>
            <Skeleton loading={props.loading}>{props.subtitle}</Skeleton>
          </Typography>
          <Sheet sx={{ bgcolor: 'background.level1', borderRadius: 'sm', p: 1.5, my: 1.5, display: 'flex', gap: 2, '& > div': { flex: 1 } }}>
            {props.details.map(d => 
              <div key={d[0]}>
                <Typography level="body-xs" sx={{ fontWeight: 'lg', ...noflo }}>
                  <Skeleton loading={props.loading}>{d[0]}</Skeleton>
                </Typography>
                <Typography sx={{ fontWeight: 'lg', ...noflo }} component="span">
                <Skeleton loading={props.loading}>{d[1]}</Skeleton>
                </Typography>
              </div>
            )}
          </Sheet>
          <Box sx={{ display: 'flex', gap: 1.5, '& > button': { flex: 1 } }}>
            {props.buttons.map(btn => (
              <div key={btn.key}>{btn}</div>
            ))}
          </Box>
        </CardContent>
      </Card>
  );
}